import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

import GameScene from './custom-components-mocks';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'gameIntegration',
        component: () => <GameScene />,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
